module.exports = __webpack_public_path__ + "img/03.4d25c41e.jpg";